import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
// import { message } from 'antd'
import FormGovermentView from 'components/pages/goverment/Form'
// import Helper from 'utils/Helper'
// import history from 'utils/history'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withHandlers({
    handleSubmit: () => () => {

    },
  }),
  lifecycle({
    componentDidMount() {
      const { match, setIsEdit } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Goverment Form',
        activePage: 'goverment',
        activeSubPage: 'goverment',
      })
      if (match.params.id) {
        setIsEdit(true)
      }
    },
  }),
)(FormGovermentView)
